module.exports = require("./smn-FI");